import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router";

export default function NotFoundPage() {

    const nav = useNavigate();

    return (
        <div className="h-screen flex items-center justify-center">
            <div>
                <div className="text-center">
                    <h1 className="font-extrabold text-2xl">Not found</h1>
                    <p>The page you requested could not be found</p>
                    <p><button onClick={() => nav(-1)} className="link link-hover link-info flex items-center justify-center gap-2 w-full"><ArrowLeft /> Back</button></p>
                </div>
            </div>
        </div>
    );
}